import React, { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';
// import { Music } from './services/music';
import { Activity } from './services/activity';
import { Pension } from './services/pension';
import { OtherActivity } from './services/otherActivity';
import { Tenant } from './services/tenant';
import { Ehpad } from './services/ehpad';
import {ServiceNavbar} from './serviceNavbar';
import {DefaultService} from './services/defaultService';
import {ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, isSocialNetwork} from '../../../constants/utils/connectionTypes';
import {EmptyState} from './emptyState';
import { getProgress } from '../../anticipa/_common/serviceNavbar/calculateProgress';
import { useSelector } from 'react-redux';
import { BranchService } from './services/branchService';

export const ServicesEdit = ({ selectedService, setSelectedService }) => {
	const serviceModalRef = useRef(null);
	const user = useSelector(state => state.user);
	const servicesData = useSelector(state => state.services);
	const [commonOptions, setCommonOptions] = useState([]);
	const [personnalOptions, setPersonnalOptions] = useState([]);
	const [otherOption, setOtherOption] = useState([]);

	const [showCompleteState, setShowCompleteState] = useState(false);

    function isInsurance(str) {
        if (str === ConnectionTypes.voitureAssurance || str === ConnectionTypes.bateau || str === ConnectionTypes.moto || str === ConnectionTypes.scooter) {
            return true;
        }
        return false;
	}
	
	// const handleClickOutside = (event) => {
    //     if (serviceModalRef.current && !serviceModalRef.current.contains(event.target)) {
    //         setShowCompleteState(undefined);
    //     }
    // };
	function service(connectionType, title, icon, detailedDescription) { return { connectionType: connectionType, title: title, icon: icon, detailedDescription:detailedDescription } };

	useEffect(() => {
        let tmp = [];
        [PersonalServices, AuxiliarOptions].forEach(services => {
        	Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon, obj.detailedDescription));
            });
        });
		setPersonnalOptions(tmp);
		tmp = [];
        [CommonServices].forEach(services => {
            Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon, obj.detailedDescription));
            });
		});
		setCommonOptions(tmp);
		tmp = [];
		[OtherService].forEach(services => {
            Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon, obj.detailedDescription));
            });
        });
		setOtherOption(tmp);
		//document.addEventListener('click', handleClickOutside, true);
		
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!R.isNil(personnalOptions) && !R.isNil(commonOptions) && personnalOptions.length > 0 && commonOptions.length > 0){
			
			let everythingIsComplete = true;
			if (!R.isNil(selectedService)) {
				personnalOptions.filter(u => user.services.findIndex(i => isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType :
					isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType) !== -1).forEach((s) => {
						let progress = getProgress(servicesData.serviceData, s.connectionType);
						if (progress !== 100) {
							everythingIsComplete = false;
							return;
						}
					});
				commonOptions.filter(u => user.services.findIndex(i => i.connectionType === u.connectionType) !== -1).forEach((s) => {
					let progress = getProgress(servicesData.serviceData, s.connectionType);
					if (progress !== 100) {
						everythingIsComplete = false;
						return;
					}
				});
				otherOption.filter(u => user.services.findIndex(i => i.connectionType === u.connectionType) !== -1).forEach((s) => {
					let progress = getProgress(servicesData.serviceData, s.connectionType);
					if (progress !== 100) {
						everythingIsComplete = false;
						return;
					}
				});
			}
			if (everythingIsComplete === true/* && complete === false*/){
				setShowCompleteState(true);
			}else{
				setShowCompleteState(false);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedService, servicesData.serviceData[selectedService], servicesData.isLoading /*!R.isNil(selectedService) && !R.isNil(servicesData.serviceData) && !R.isNil(servicesData.serviceData[selectedService]) && servicesData.serviceData[selectedService].length*/]);


	useEffect(() => {
		setShowCompleteState(false);
	}, [selectedService]);

	// useEffect(() => {
	// 	document.addEventListener('click', handleClickOutside, true);
	// 	return () => {
	// 		document.removeEventListener('click', handleClickOutside, true);
	// 	};
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// });

	let selectedServiceOption = [].concat(personnalOptions, commonOptions, otherOption).find(s => s.connectionType === selectedService);
	return (
		<div className="modal fade px-0" id="servicesEdit" aria-labelledby="servicesEditLabel" aria-hidden="true" ref={serviceModalRef}>
			<div className="modal-dialog px-2 modal-dialog-scrollable container-modal">
				<div className="modal-content bg-light">
					<div className="modal-header">
						<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Services</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-primary text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="infoValiderLabel">remplir les champs</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body scroll-default no-auto-overflow pt-0">
						<div className="grid grid-1 grid-auto-row grid-auto-aside grid-auto-scroll">
							<ServiceNavbar selectedService={selectedService} setSelectedService={setSelectedService} personnalOptions={personnalOptions} commonOptions={commonOptions} otherOption={otherOption} ConnectionTypes={ConnectionTypes}/>
							<section className="block">
								<h2 className="sr-only visually-hidden">Services setup</h2>
								{
									(() => {
										if(showCompleteState)
											return <EmptyState />

										if(R.isNil(selectedService) && selectedService === '')
											return '';

										if(R.isNil(selectedServiceOption))
											return '';
											
										switch(selectedService){
											case ConnectionTypes.bank:
												return <BranchService connectionType={ConnectionTypes.bank} title="Banque" />;

											case ConnectionTypes.sport:
												return <BranchService connectionType={ConnectionTypes.sport} title="Sport" />;

											case ConnectionTypes.activity:
												return <Activity />;

											case ConnectionTypes.pension:
												return <Pension />;

											case ConnectionTypes.otherActivity:
												return <OtherActivity />;

											case ConnectionTypes.locataire:
												return <Tenant />;

											case ConnectionTypes.ehpad:
												return <Ehpad />;

											default:
												return <DefaultService serviceTitle={selectedServiceOption.title} serviceDetailedDescription={selectedServiceOption.detailedDescription} connectionType={selectedService} serviceType={selectedServiceOption.connectionType} />;

										}										
									})()
								}
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}